export const LetterPreviewOnHover = {
  mounted() {
    this.loaded = false;
    this.loading = false;
    this.rafId = null;
    this.hoverIntentId = null;
    this.tooltip = this.el.querySelector("[data-letter-preview-tooltip]");
    this.img = this.el.querySelector("[data-document-preview]");
    this.rowRect = null;
    this.tooltipHalfWidth = null;

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);

    this.el.addEventListener("mouseenter", this.handleMouseEnter);
    this.el.addEventListener("mouseleave", this.handleMouseLeave);
  },

  destroyed() {
    this.el.removeEventListener("mouseenter", this.handleMouseEnter);
    this.el.removeEventListener("mouseleave", this.handleMouseLeave);
    this.el.removeEventListener("mousemove", this.handleMouseMove);
  },

  async handleMouseEnter(e) {
    this.rowRect = this.el.getBoundingClientRect();
    this.tooltipHalfWidth = this.tooltip ? this.tooltip.getBoundingClientRect().width / 2 : 0;
    this.updateTooltipPosition(e);
    this.el.addEventListener("mousemove", this.handleMouseMove);

    if (this.loaded || this.loading || !this.img) return;

    this.hoverIntentId = setTimeout(async () => {
      this.hoverIntentId = null;
      this.loading = true;

      try {
        const preview_url = await this.load_preview(this.img);
        if (!preview_url) return;

        this.apply_preview(this.img, preview_url);
        this.loaded = true;
      } catch (error) {
        console.error("Failed to load letter preview", error);
      } finally {
        this.loading = false;
      }
    }, 200);
  },

  handleMouseMove(e) {
    if (this.rafId) cancelAnimationFrame(this.rafId);
    this.rafId = requestAnimationFrame(() => {
      this.updateTooltipPosition(e);
      this.rafId = null;
    });
  },

  handleMouseLeave() {
    this.el.removeEventListener("mousemove", this.handleMouseMove);
    if (this.rafId) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    if (this.hoverIntentId) {
      clearTimeout(this.hoverIntentId);
      this.hoverIntentId = null;
    }
  },

  updateTooltipPosition(e) {
    if (!this.tooltip) return;

    let left = e.clientX - this.rowRect.left;
    left = Math.max(this.tooltipHalfWidth, Math.min(this.rowRect.width - this.tooltipHalfWidth, left));
    this.tooltip.style.left = `${left}px`;
  },

  async load_preview(img) {
    const url = img.dataset.previewUrl;
    if (!url) return;

    const response = await fetch(url, { headers: { accept: "application/json" } });
    if (!response.ok) return;

    const data = await response.json();
    return data.preview_url;
  },

  apply_preview(img, preview_url) {
    img.src = preview_url;
    img.classList.remove("hidden");
  },  
};
